export const invoiceFileName = (inv) => {
  const mm = (inv.date || "").slice(5, 7) || "00";
  const no = (inv.invoice_no || "invoice").replace(/[\\/:*?"<>|\s]+/g, "-").replace(/^-+|-+$/g, "");
  return `${mm}-${no}.pdf`;
};

export const termLabel = (inv) => {
  if (inv.invoice_type === "pelunasan") return "Pelunasan";
  if (inv.invoice_type === "dp") return Number(inv.term_no || 1) > 1 ? `Termin ${inv.term_no}` : "DP · Termin 1";
  return "Tunai";
};

export const saveBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
};
